import React, {FC} from 'react';
import styled from 'styled-components';

import {BoxedInput} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {
  BoxedInputElement,
  BoxedInputElementTypesEnum,
} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInputElement';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Constants.
 */

const inputWidth = 80;

/*
 * Props.
 */

interface GlobalPhoneNumberInputProps {
  hasError: boolean;
  phoneCountryCode: string;
  onChange: (arg: string) => void;
  onBlur?: () => void;
}

/*
 * Style.
 */

const StyledBoxedInput = styled(BoxedInput)`
  width: ${inputWidth}px;
`;

/*
 * Component.
 */

export const PhoneCountryCodeInputBox: FC<GlobalPhoneNumberInputProps> = (props) => {
  const {hasError, onChange, onBlur, phoneCountryCode} = props;
  return (
    <StyledBoxedInput hasError={hasError}>
      {(childProps) => (
        <BoxedInputElement
          {...childProps}
          type={BoxedInputElementTypesEnum.TEXT}
          onChange={onChange}
          onBlur={onBlur}
          defaultValue={phoneCountryCode}
          size={VisualSizesEnum.MEDIUM}
        />
      )}
    </StyledBoxedInput>
  );
};
